import React, { PropsWithChildren, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Grid } from '@mui/material';

import Alerts from 'views/Alerts';

import { setLogoApp } from 'store/globalApp';

import { getOfficeById } from 'api/user/offices';

import { getInvestmentOfficeId } from 'utils/access';
import { useDevice } from 'hooks';

import SideBarMenu from './SideBarMenu';
import Header from './Header';
import MobileHeader from './MobileHeader';
import TabsNavigator from './TabsNavigator';

import {
  rootStyles,
  tabsContainerMobileStyles,
  tabsContainerStyles,
} from './styles';

const Layout = ({ children }: PropsWithChildren) => {
  const dispatch = useDispatch();
  const { isMobile } = useDevice();

  useEffect(() => {
    getOfficeById(getInvestmentOfficeId()).then((resp) => {
      const { success, data } = resp;
      if (success && data && data.data && data.data.imageData) {
        dispatch(setLogoApp(`data:image/jpeg;base64,${data.data.imageData}`));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container sx={rootStyles}>
      {isMobile ? (
        <MobileHeader />
      ) : (
        <>
          <SideBarMenu />
          <Header />
        </>
      )}
      <Grid
        container
        sx={[
          tabsContainerStyles,
          ...(isMobile ? [tabsContainerMobileStyles] : []),
        ]}
      >
        <TabsNavigator />
      </Grid>
      <Alerts />

      {children}
    </Grid>
  );
};

export default Layout;
